export default __webpack_public_path__ + "static/linkedin-f50aca48ddcf673f6b6138e4daf4e9c0.svg";